import axios from "axios"
import sessionServices from "./sessionServices"

const rsApiRequestV3 = axios.create({
  baseURL: `${process.env.REACT_APP_ROSTERSPOT_API_BASE_URL_V3}/api/v3`,
})

rsApiRequestV3.interceptors.request.use(
  function (config) {
    config.headers.common["Authorization"] = 'Bearer ' + sessionServices.getAuthToken()
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

rsApiRequestV3.interceptors.response.use(
  (response) => {
    let rs = response.data
    if (response.data.result) {
      rs = response.data.result
      rs.isOk = true
    }

    return rs
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default rsApiRequestV3
